import tallyAndValidateChoiceSets from './tallyAndValidateChoiceSets';
import choiceSetsWithQuantities from './choiceSetsWithQuantities';
import choiceSelectionsFromBase from './choiceSelectionsFromBase';
import {
  getLegacyDaypartsAvailability,
  getDaypartAvailability,
} from './daypartMenuAvailability';

const validateUpsellItems = (
  items: Item[],
  stockBalanceDataMap?: SDict<StockBalanceData>,
  choiceSetDiscountConfig?: ChoiceSetQuantityDiscountConfig,
  dateTimeSelected?: string,
  daypartSlots?: DaypartMap,
): (Item & { upsellAvailable: boolean })[] | undefined => {
  const result: ({ upsellAvailable: boolean } & Item)[] = [];
  items.forEach(item => {
    const { choiceSets } = item;

    //pre selection validate
    const ChoiceSelections = choiceSelectionsFromBase(
      choiceSets,
      undefined,
      stockBalanceDataMap,
    );
    const validatedSets = tallyAndValidateChoiceSets(
      choiceSetsWithQuantities(choiceSets, ChoiceSelections),
      choiceSetDiscountConfig,
    );
    const isValidItem = validatedSets.reduce(
      (acc: boolean, current) => acc && current.valid,
      true,
    );

    if (isValidItem) {
      const { availability, days, start, end, dayparts } = item;
      //stock balance validate
      const stockBalanceData =
        stockBalanceDataMap &&
        item.plucode &&
        stockBalanceDataMap[item.plucode];

      let daypartAvailable: boolean;
      if (dayparts && dayparts.length > 0 && daypartSlots) {
        daypartAvailable = getDaypartAvailability({
          dayparts,
          daypartSlots,
          dateTimeSelected,
        });
      } else {
        daypartAvailable = getLegacyDaypartsAvailability({
          availability,
          days,
          start,
          end,
          dateTimeSelected,
        });
      }

      const upsellAvailable =
        !!(
          !stockBalanceData ||
          (stockBalanceData && (stockBalanceData.cartAdjustedBalance || 0) > 0)
        ) && daypartAvailable;

      result.push({ ...item, upsellAvailable });
    }
  });

  return result;
};

export default validateUpsellItems;
